import { render } from "./SignApp.vue?vue&type=template&id=48546c3a&scoped=true"
import script from "./SignApp.vue?vue&type=script&lang=js"
export * from "./SignApp.vue?vue&type=script&lang=js"

import "./SignApp.vue?vue&type=style&index=0&id=48546c3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48546c3a"]])

export default __exports__